import { atom } from 'nanostores';

/**
 * Version peek state. The preview pane owns rendering; Chat.client owns the
 * actual restore (it holds handleRestore with the in-flight guards), so the
 * banner CTA communicates through $restoreRequest instead of calling into
 * the chat tree directly.
 */
export const $peekVersion = atom<string | null>(null);
export const $restoreRequest = atom<string | null>(null);

export function requestRestore(messageId: string) {
  $restoreRequest.set(messageId);
}

export function exitPeek() {
  $peekVersion.set(null);
}
